import React, { Component } from 'react';
import { Col, FormGroup, ControlLabel, FormControl, Row } from 'react-bootstrap';

//import FormSectionStatus from './FormSectionStatus';
import { updateTeas } from '../actions';

class Teas extends Component {
  constructor(props){
    super(props);
    this.handleTeasChanges = this.handleTeasChanges.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleScoreChange = this.handleScoreChange.bind(this);
    this.handleTimesTakenChange = this.handleTimesTakenChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  handleLocationChange(e){
    const updates = { location: e.target.value };
    this.handleTeasChanges(updates);
  }

  handleDateChange(e){
    const updates = { date: e.target.value };
    this.handleTeasChanges(updates);
  }

  handleScoreChange(e){
    const updates = { score: e.target.value };
    this.handleTeasChanges(updates);
  }

  handleTimesTakenChange(e){
    const updates = { timesTaken: e.target.value };
    this.handleTeasChanges(updates);
  }

  handleTeasChanges(updates){
    const {dispatch} = this.props;
    dispatch(updateTeas(updates));
  }

  render() {
    const { location, date, score, timesTaken } = this.props.teas;

    return (
      <Row>
        <Col md={5}>
          <FormGroup
            controlId="teas-location"
          >
            <ControlLabel>
              Place/Location TEAS was Taken
            </ControlLabel>
            <FormControl
              componentClass="input"
              type="text"
              value={location}
              placeholder="Enter TEAS Location"
              onChange={this.handleLocationChange}
            />
            <FormControl.Feedback />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup
            controlId="teas-date"
          >
            <ControlLabel>
              Date Taken
            </ControlLabel>
            <FormControl
              componentClass="input"
              type="date"
              value={date}
              placeholder="Date"
              onChange={this.handleDateChange}
            />
            <FormControl.Feedback />
          </FormGroup>
        </Col>
        <Col md={2}>
          <FormGroup
            controlId="teas-score"
          >
            <ControlLabel>
              Score*
            </ControlLabel>
            <FormControl
              componentClass="input"
              type="number"
              value={score}
              placeholder="Enter Score"
              onChange={this.handleScoreChange}
            />
            <FormControl.Feedback />
          </FormGroup>
        </Col>
        <Col md={2}>
          <FormGroup
            controlId="teas-times-taken"
          >
            <ControlLabel>
              TEAS Attempts
            </ControlLabel>
            <FormControl
              componentClass="input"
              type="number"
              value={timesTaken}
              placeholder="Enter Attempts"
              onChange={this.handleTimesTakenChange}
            />
            <FormControl.Feedback />
          </FormGroup>
        </Col>
      </Row>
    );
  };
}

export default Teas;